export default __webpack_public_path__ + "static/DEIPage-pattern-medium-darkpurple-4a93951d486bcd191a2379dee2c24671.png";